import React from 'react'
import PropTypes from 'prop-types'
import { Tabs, TabPanel } from '@paypalcorp/pp-react'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import _get from 'lodash/get'
import CampaignDetails from 'components/pages/campaign/campaign_details'
import PublicContributionsList from 'components/contributions_list/public_contributions_list'
import styles from './crowdfunding_tab_layout.less'

const i18n = getI18n('components/crowdfunding_tab_layout')

class CrowdFundingTabLayout extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    contributions: PropTypes.array,
    pledge: PropTypes.number,
  }

  state = {
    selectedTabIdx: 0,
  }

  tabHandler(e) {
    this.setState({ selectedTabIdx: e.currentTarget.dataset.tabIndex })
  }

  render() {
    let contributionCount = _get(this.props, 'contributions.length', 0)
    if (this.props.pledge > 0) {
      contributionCount = contributionCount + 1
    }
    return (
      <Tabs
        name="TabLayout"
        selectedTabIdx={this.state.selectedTabIdx}
        tabs={[
          { label: i18n('about_title'), id: 'about-tab', panelId: 'about-tab' },
          {
            label: i18n('contribution_title', { count: contributionCount }),
            id: 'contributors-tab',
            panelId: 'contributors-tab',
          },
        ]}
        onClick={this.tabHandler.bind(this)}
      >
        <TabPanel id="about-tab" styleName="tab_content">
          <CampaignDetails
            campaignId={this.props.campaignId}
            tab_layout={true}
          />
        </TabPanel>

        <TabPanel id="contributors-tab" styleName="tab_content">
          <PublicContributionsList
            campaignId={this.props.campaignId}
            hideChipIn={true}
          />
        </TabPanel>
      </Tabs>
    )
  }
}
export default cssModules(CrowdFundingTabLayout, styles, {
  allowMultiple: true,
})
